import React from 'react';
import AICustomization from '../components/story/AICustomization';

const AITunePage = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-serif font-bold text-gray-900 dark:text-white mb-8">AI Tuning & Customization</h1>
      <div className="bg-white dark:bg-purple-900/20 p-8 rounded-3xl border border-gray-100 dark:border-purple-800 shadow-xl">
        <AICustomization />
      </div>
    </div>
  );
};

export default AITunePage;
